module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('group-title', [_vm._v("分享您的使用心得。推荐朋友。")]), _vm._v(" "), _c('div', {
    staticClass: "ref_content"
  }, [_c('x-button', {
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        _vm.showQrHandler($event)
      }
    }
  }, [_vm._v("查看二维码")]), _vm._v(" "), _c('x-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.hasNoUserCard
    },
    nativeOn: {
      "click": function($event) {
        _vm.showUserCard($event)
      }
    }
  }, [_vm._v("查看名片")]), _vm._v(" "), _c('group-title', [_vm._v("选择模板，生成名片")]), _vm._v(" "), _c('x-button', {
    attrs: {
      "type": "warn",
      "link": "/uc/usercard"
    }
  }, [_vm._v("生成名片")])], 1), _vm._v(" "), _c('div', [_c('x-dialog', {
    staticClass: "dialog-demo",
    model: {
      value: (_vm.showQr),
      callback: function($$v) {
        _vm.showQr = $$v
      },
      expression: "showQr"
    }
  }, [_c('div', {
    staticClass: "img-box"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "src": _vm.qrCode
    }
  })]), _vm._v(" "), _c('div', {
    on: {
      "click": function($event) {
        _vm.showQr = false
      }
    }
  }, [_c('span', {
    staticClass: "vux-close"
  })])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4b122a2e"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/uc/ReferImgIndex.vue
// module id = 681
// module chunks = 0